import editDealDetails from './editDealDetails';

export default {
  editDealDetails,
};
